module.exports = __webpack_public_path__ + "static/media/criminal.ac71f7cb.svg";